import Vue from 'vue';
import Vuex from 'vuex';
// eslint-disable-next-line import/no-cycle
import API from './api/api';

Vue.use(Vuex);

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

export default new Vuex.Store({
  state: {
    layout: null,
    logged: false,
    currentUser: null,
    cabinet: null,
    cardCode: undefined,

    open: false,
    id: null,
    seid: 0,
    iid: 0,
  },

  getters: {
    'user/isLogged': (state) => state.logged,
    getLayout(state) {
      return state.layout;
    },
    getCurrentUser(state) {
      return state.currentUser;
    },
    getCabinet(state) {
      return state.cabinet;
    },
    cardCode: (s) => s.cardCode,

    open: (s) => s.open,
    id: (s) => s.id,
    seid: (s) => s.seid,
    iid: (s) => s.iid,
  },

  mutations: {
    cardCode(state, value) {
      state.cardCode = value;
    },
    layout(state, value) {
      state.layout = value;
    },
    logged(state, value) {
      state.logged = value;
    },
    login(state) {
      state.logged = true;
    },
    logout(state) {
      state.logged = false;
    },
    cabinet(state, value) {
      state.cabinet = value;
    },
    setUser(state, value) {
      state.currentUser = value;
    },
    set(state, {
      key,
      val,
    }) {
      state[key] = val;
    },

    open(s) {
      s.open = true;
    },
    close(s) {
      s.open = false;
    },
    clear(s) {
      s.id = null;
      s.seid = 0;
      s.iid = 0;
    },
    id(s, id) {
      s.id = id;
    },
    seid(s, seid) {
      s.seid = seid;
    },
    iid(s, iid) {
      s.iid = iid;
    },
  },

  actions: {
    async layout({
      commit,
    }) {
      const response = await API.getLayout();
      commit('layout', response);
      global.console.log('store loaded layout');
    },

    async cabinet({
      commit,
    }) {
      const response = await API.getCabinet();
      const { profile: { cardCode = undefined } = {} } = response;
      commit('cardCode', cardCode);
      commit('cabinet', response);
      global.console.log('store loaded cabinet');
    },

    'user/isLogged': ({
      commit,
      state,
    }) => {
      if (state.logged) {
        return;
      }
      if (document.cookie.indexOf('token=') !== -1) {
        let avatar = getCookie('avatar');
        let username = getCookie('username');
        if (avatar.indexOf('base64') !== -1) {
          avatar = window.decodeURIComponent(avatar.slice(6));
          avatar = window.atob(avatar);
        }
        if (username.indexOf('base64') !== -1) {
          username = window.decodeURIComponent(username.slice(6));
          username = window.atob(username);
        }
        commit('setUser', {
          token: getCookie('token'),
          username,
          avatar,
        });
        commit('login');
      } else {
        commit('logout');
      }
    },

    open({ commit }, id) {
      if (id) {
        commit('id', id);
      }
      commit('open');
    },
    openService({ commit }, { id, seid }) {
      if (id) {
        commit('id', id);
      }
      if (seid) {
        commit('seid', seid);
      }
      commit('open');
    },
    openItem({ commit }, { id, iid }) {
      if (id) {
        commit('id', id);
      }
      if (iid) {
        commit('iid', iid);
      }
      commit('open');
    },
    openServiceItem({ commit }, { id, openId, type }) {
      if (id) {
        commit('id', id);
      }
      if (type === 'service') {
        commit('seid', openId);
      }
      if (type === 'item') {
        commit('iid', openId);
      }
      commit('open');
    },
    close({ commit }) {
      commit('close');
      commit('clear');
    },
    id({ commit }, value) {
      commit('id', value);
    },
    seid({ commit }, seid) {
      commit('seid', seid);
    },
    iid({ commit }, value) {
      commit('iid', value);
    },
  },
});
